import { useContext,useEffect  } from "react";
import { useHistory } from "react-router";

import { AuthenticationContext } from "../../providers/authentication/AuthenticationContext";

export default function useRedirectIfNotAuthenticated(
  link: Parameters<ReturnType<typeof useHistory>["replace"]>[0],
) {
  const history = useHistory();
  const auth = useContext(AuthenticationContext);
  useEffect(() => {
    if (!auth.userId) {
      history.replace(link);
    }
  }, [auth, history, link]);
}
